export const listInvoiceItems = `
   query listInvoiceItems($filter: InvoiceItemsFilterInput, $limit: Int, $nextToken: String) {
       listInvoiceItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
                id
                customerId
                amount
                currency
                description
                period {
                    start
                    end
                }
                price
                invoice
                quantity
                subscription
                unitAmount
           }
           nextToken
       }
   }
`;

export const getInvoiceItem = `
   query getInvoiceItem($id:ID!) {
       getInvoiceItem(id:$id) {
            id
            customerId
            amount
            currency
            description
            period {
                start
                end
            }
            price
            invoice
            quantity
            subscription
            unitAmount
       } 
}`;
